<template>
  <div
    ref="hammer-target"
    class="tree-animation"
  >
    <div
      v-show="showTree"
      ref="img-wrapper"
      class="img-wrapper"
      @scroll="onImgWrapperScroll"
    >
      <div
        class="img-wrapper-tall"
        @mousedown="onMouseDown"
        @mousemove="onMouseMove"
        @mouseup="onMouseUp"
      >
        <img
          ref="tree-image"
          class="tree-image"
          src="@/assets/image/tall-tree-no-fruit.png"
          alt=""
          draggable="false"
          @load="onTreeImgLoad"
        >
        <!-- 各标签（果子）的代码顺序与显示顺序上下相反 -->
        <img
          src="@/assets/image/fruits/金色中国.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 2.5rem;
            height: calc(10.16rem + 0.78rem);
            left: 10.11rem;
            top: calc(407.38rem - 0.78rem)
          "
          @click="onClickFruit('traditionModern', 's')"
        >
        <img
          src="@/assets/image/fruits/在此.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(8.89rem + 0.78rem);
            left: 10.06rem;
            top: calc(379.63rem - 0.78rem)
          "
          @click="onClickFruit('wuyiba', 'a')"
        >
        <img
          src="@/assets/image/fruits/藏品架起沟通的桥梁.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(8.28rem + 0.78rem);
            left: 8.8rem;
            top: calc(358.94rem - 0.78rem)
          "
          @click="onClickFruit('wuyiba', 'f')"
        >
        <img
          src="@/assets/image/fruits/温婉.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 2.5rem;
            height: calc(10.28rem + 0.78rem);
            left: 11.17rem;
            top: calc(337.6rem - 0.78rem)
          "
          @click="onClickFruit('traditionModern', 'p')"
        >
        <img
          src="@/assets/image/fruits/和合.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(8.92rem + 0.78rem);
            left: 12.88rem;
            top: calc(318.63rem - 0.78rem)
          "
          @click="onClickFruit('traditionModern', 'u')"
        >
        <img
          src="@/assets/image/fruits/南腔北调.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(9.31rem + 0.78rem);
            left: 7.14rem;
            top: calc(317.82rem - 0.78rem)
          "
          @click="onClickFruit('traditionModern', 'oa')"
        >
        <img
          src="@/assets/image/fruits/呼吸.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(9.89rem + 0.78rem);
            left: 9.59rem;
            top: calc(299.22rem - 0.78rem)
          "
          @click="onClickFruit('wuyiba', 'c')"
        >
        <img
          src="@/assets/image/fruits/法老王.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.75rem;
            height: calc(10.47rem + 0.78rem);
            left: 7.34rem;
            top: calc(280.1rem - 0.78rem)
          "
          @click="onClickFruit('traditionModern', 't')"
        >
        <img
          src="@/assets/image/fruits/缀白裘.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(8.59rem + 0.78rem);
            left: 7.34rem;
            top: calc(262.49rem - 0.78rem)
          "
          @click="onClickFruit('wuyiba', 'b')"
        >
        <img
          src="@/assets/image/fruits/帝国盛世.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(8.59rem + 0.78rem);
            left: 11.58rem;
            top: calc(254.6rem - 0.78rem)
          "
          @click="onClickFruit('traditionModern', 'z')"
        >
        <img
          src="@/assets/image/fruits/青藤.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.75rem;
            height: calc(8.59rem + 0.78rem);
            left: 7.69rem;
            top: calc(242.05rem - 0.78rem)
          "
          @click="onClickFruit('traditionModern', 'x')"
        >
        <img
          src="@/assets/image/fruits/走进.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(10.11rem + 0.78rem);
            left: 12.7rem;
            top: calc(237.9rem - 0.78rem)
          "
          @click="onClickFruit('traditionModern', 'o')"
        >
        <img
          src="@/assets/image/fruits/回家过年.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(8.2rem + 0.78rem);
            left: 6.58rem;
            top: calc(223.69rem - 0.78rem)
          "
          @click="onClickFruit('traditionModern', 'za')"
        >
        <img
          src="@/assets/image/fruits/穆夏.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(9.22rem + 0.78rem);
            left: 10.8rem;
            top: calc(214.5rem - 0.78rem)
          "
          @click="onClickFruit('wuyiba', 'd')"
        >
        <img
          src="@/assets/image/fruits/称霸侏罗纪.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(9.38rem + 0.78rem);
            left: 6.69rem;
            top: calc(207.22rem - 0.78rem)
          "
          @click="onClickFruit('theme', 'j')"
        >
        <img
          src="@/assets/image/fruits/世界巨匠.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(10.67rem + 0.78rem);
            left: 10.48rem;
            top: calc(198.3rem - 0.78rem)
          "
          @click="onClickFruit('theme', 'h')"
        >
        <img
          src="@/assets/image/fruits/暑期.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(7.19rem + 0.78rem);
            left: 6.94rem;
            top: calc(184.8rem - 0.78rem)
          "
          @click="onClickFruit('theme', 'l')"
        >
        <img
          src="@/assets/image/fruits/金色阿富汗.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(11.34rem + 0.78rem);
            left: 10.8rem;
            top: calc(173.7rem - 0.78rem)
          "
          @click="onClickFruit('theme', 'k')"
        >
        <img
          src="@/assets/image/fruits/从毕加索.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(8.98rem + 0.78rem);
            left: 5.84rem;
            top: calc(167.1rem - 0.78rem)
          "
          @click="onClickFruit('theme', 'g')"
        >
        <img
          src="@/assets/image/fruits/兄弟王.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(10.92rem + 0.78rem);
            left: 10.67rem;
            top: calc(155.8rem - 0.78rem)
          "
          @click="onClickFruit('traditionModern', 'v')"
        >
        <img
          src="@/assets/image/fruits/仰之弥高.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(8.44rem + 0.78rem);
            left: 6.39rem;
            top: calc(156rem - 0.78rem)
          "
          @click="onClickFruit('traditionModern', 'y')"
        >
        <img
          src="@/assets/image/fruits/融合.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.75rem;
            height: calc(9.13rem + 0.78rem);
            left: 11.89rem;
            top: calc(143.61rem - 0.78rem)
          "
          @click="onClickFruit('wuyiba', 'e')"
        >
        <img
          src="@/assets/image/fruits/晶华.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 2.5rem;
            height: calc(7.81rem + 0.78rem);
            left: 8.72rem;
            top: calc(133.5rem - 0.78rem)
          "
          @click="onClickFruit('theme', 'm')"
        >
        <img
          src="@/assets/image/fruits/百花呈瑞.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(8.56rem + 0.78rem);
            left: 10.72rem;
            top: calc(121rem - 0.78rem)
          "
          @click="onClickFruit('traditionModern', 'w')"
        >
        <img
          src="@/assets/image/fruits/考古江苏.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(7.81rem + 0.78rem);
            left: 10.23rem;
            top: calc(103.85rem - 0.78rem)
          "
          @click="onClickFruit('traditionModern', 'r')"
        >
        <img
          src="@/assets/image/fruits/浮世绘.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 2.5rem;
            height: calc(5rem + 0.78rem);
            left: 8.53rem;
            top: calc(93.8rem - 0.78rem)
          "
          @click="onClickFruit('theme', 'n')"
        >
        <img
          src="@/assets/image/fruits/宋韵.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(8.28rem + 0.78rem);
            left: 9.11rem;
            top: calc(81.16rem - 0.78rem)
          "
          @click="onClickFruit('traditionModern', 'q')"
        >
        <img
          src="@/assets/image/fruits/万水千山.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            height: calc(12.23rem + 0.78rem);
            left: 9rem;
            top: calc(60.4rem - 0.78rem)
          "
          @click="onClickFruit('theme', 'i')"
        >
        <img
          src="@/assets/image/fruits/潘玉良.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            left: 8rem;
            top: 51rem;
          "
          @click="onClickFruit('traditionModern', 'zb')"
        >
        <img
          src="@/assets/image/fruits/晋国.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            left: 11rem;
            top: 38.8rem;
          "
          @click="onClickFruit('traditionModern', 'zc')"
        >
        <img
          src="@/assets/image/fruits/家国.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            height: 2.3rem;
            left: 3.4rem;
            top: 20.8rem;
            cursor: initial;
          "
        >
        <img
          src="@/assets/image/fruits/家国-爱国有义.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 1.6rem;
            left: 4rem;
            top: 23rem;
          "
          @click="onClickFruit('wuyiba', 'aa')"
        >
        <img
          src="@/assets/image/fruits/家国-恩义好台.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 1.6rem;
            left: 7rem;
            top: 23rem;
          "
          @click="onClickFruit('wuyiba', 'ab')"
        >
        <img
          src="@/assets/image/fruits/家国-兄弟一心.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 1.6rem;
            left: 10rem;
            top: 23rem;
          "
          @click="onClickFruit('wuyiba', 'ac')"
        >
        <img
          src="@/assets/image/fruits/家国-慈孝有亲.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 1.6rem;
            left: 13rem;
            top: 23rem;
          "
          @click="onClickFruit('wuyiba', 'ad')"
        >
        <img
          src="@/assets/image/fruits/家国-太平天下.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 1.6rem;
            left: 16rem;
            top: 23rem;
          "
          @click="onClickFruit('wuyiba', 'ae')"
        >
        <img
          src="@/assets/image/fruits/大江.png"
          class="fruit"
          alt=""
          draggable="false"
          style="
            width: 3.13rem;
            left: 4.3rem;
            top: 1.5rem;
          "
          @click="onClickFruit('traditionModern', 'zd')"
        >
      </div>
    </div>
    <SlideTip
      v-show="showSlideTip && showTree"
      class="slide-tip"
    />
    <van-loading
      v-show="!showTree"
      color="#1989fa"
      class="loading"
      type="spinner"
      size="3rem"
      vertical
    >
      <!-- <span style="font-size: 1rem;">
        {{ frameLoadProgress }}
      </span> -->
    </van-loading>
    <img
      class="background-image"
      src="@/assets/image/bg.png"
      alt="background"
    >
  </div>
</template>

<script>
import VisSenseFactory from 'vissense'
const VisSense = VisSenseFactory(window)

export default {
  name: 'TreeAnimation',
  data() {
    return {
      showTree: false,
      showSlideTip: false,
      visMonitorList: [],
      scrollTop: 0,

      /**
       * 为了PC端也能拖动树木
       */
      isMouseDown: false,
      isTreeDragged: false,
    }
  },
  computed: {

  },
  created() {

  },
  mounted() {
    const fruitNodeList = document.getElementsByClassName('fruit')
    for (const iterator of fruitNodeList) {
      let visMonitor = VisSense(iterator).monitor({
        percentagechange: function (VisMon) {
          if (VisMon._state.percentage > 0.5) {
            iterator.style.opacity = "1"
            visMonitor.stop()
          }
        }
      })
      this.visMonitorList.push(visMonitor)
      visMonitor.start()
    }
  },
  activated() {
    this.$refs['img-wrapper'].scrollTop = this.scrollTop
  },
  deactivated() {
    this.scrollTop = this.$refs['img-wrapper'].scrollTop
  },
  destroyed() {
    for (const iterator of this.visMonitorList) {
      iterator.stop()
    }
  },
  methods: {
    onTreeImgLoad() {
      this.showTree = true
      this.$nextTick(() => {
        this.$refs['img-wrapper'].scrollTop = this.$refs['tree-image'].scrollHeight
      })

      let mc = new Hammer(this.$refs['hammer-target'])
      mc.get('pan').set({ direction: Hammer.DIRECTION_ALL })
      const that = this
      mc.on("pandown", function me() {
        if (that.$refs['img-wrapper'].scrollTop === 0 && !that.isTreeDragged) {
          that.$router.push({ name: 'TreeSelection' })
          // 因为本组件用keep-alive来避免销毁了，所以可能会多次用到下滑翻页功能，所以此处不能off。
          // mc.off('pandown', me)
        } else {
          return
        }
      })
    },
    onImgWrapperScroll(e) {
      if (this.$refs['tree-image'].scrollHeight - window.innerHeight - e.target.scrollTop <= 50) {
        this.showSlideTip = true
      } else if ( e.target.scrollTop === 0) {
        this.showSlideTip = true
      } else {
        this.showSlideTip = false
      }
    },
    onClickFruit(exhibitionType, exhibitionId) {
      if (this.isTreeDragged) {
        return
      }
      this.$router.push(`/ExhibitionDetailAnimation?exhibitionType=${exhibitionType}&exhibitionId=${exhibitionId}`)
    },
    onMouseDown() {
      this.isMouseDown = true
      this.isTreeDragged = false
    },
    onMouseUp() {
      this.isMouseDown = false
    },
    onMouseMove(e) {
      if (
        this.isMouseDown &&
        !(
          this.$refs['img-wrapper'].scrollTop == 0 &&
          e.movementY > 0
        )
      ) {
        this.$refs['img-wrapper'].scrollTop -= e.movementY
        this.isTreeDragged = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.tree-animation {
  width: 100%;
  height: 100%;
  position: relative;
  > .img-wrapper {
    height: 100%;
    widows: 100%;
    animation: emerge 1s 0.7s linear forwards;
    overflow: auto;
    opacity: 0;
    > .img-wrapper-tall {
      margin: 0 auto;
      width: 18.28rem;
      position: relative;
      > .tree-image {
        display: block;
        width: 100%;
      }
      > .fruit {
        position: absolute;
        bottom: 30rem;
        left: 3rem;
        opacity: 0;
        transition: opacity 1s;
        cursor: pointer;
      }
    }
  }
  > .loading {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .background-image {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    object-fit: cover;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
}
@keyframes emerge {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
